import logo from '../../assets/logo.png'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'full' | 'mark'
  className?: string
}

const sizes = {
  sm: { mark: 20, text: 'text-sm', gap: 'gap-2' },
  md: { mark: 28, text: 'text-base', gap: 'gap-2.5' },
  lg: { mark: 36, text: 'text-xl', gap: 'gap-3' },
}

export function PrismLogo({ size = 'md', variant = 'full', className = '' }: LogoProps) {
  const s = sizes[size]

  return (
    <div className={`flex items-center ${s.gap} ${className}`}>
      <img
        src={logo}
        alt="Portico"
        width={s.mark}
        height={s.mark}
        style={{ flexShrink: 0, objectFit: 'contain' }}
      />

      {variant === 'full' && (
        <span
          className={`font-semibold tracking-[0.08em] uppercase ${s.text}`}
          style={{ color: 'var(--sidebar-text-hover)', fontFamily: 'DM Sans, sans-serif', letterSpacing: '0.1em' }}
        >
          PRISM
        </span>
      )}
    </div>
  )
}
